import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getProtocols = (page = null, limit = null, search = '') => async (dispatch) => {
    dispatch({ type: 'PROTOCOL_LOADING' })
    try {
        const { data, status } = await Axios.post('/api/protocol/getall/', { page, limit, search }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'PROTOCOL_GETALL_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'PROTOCOL_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'PROTOCOL_NOT_LOADING' })
    }
}

export const getProtocol = (protocol) => async (dispatch) => {
    dispatch({ type: 'PROTOCOL_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/protocol/get/' + protocol, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'PROTOCOL_GET_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'PROTOCOL_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'PROTOCOL_NOT_LOADING' })
    }
}

export const addProtocol = (protocoldata) => async (dispatch) => {
    try {
        const { data, status } = await Axios.post('/api/protocol/register', protocoldata, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'PROTOCOL_ADD_SUCCESS',
                payload: data
            })
        } else if (status === 264 || status === 260) {
            dispatch({
                type: 'PROTOCOL_WRONG_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'PROTOCOL_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'PROTOCOL_NOT_LOADING' })
    }
}

export const editProtocol = (protocoldata, protocol) => async (dispatch) => {
    try {
        const { data, status } = await Axios.put('/api/protocol/edit/' + protocol, protocoldata, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200 || status === 264) {
            dispatch({
                type: 'PROTOCOL_EDIT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({ type: 'PROTOCOL_NOT_LOADING' })
    }
}

export const completeTask = (protocolId, taskIndex) => async (dispatch) => {
    try {
        const { data, status } = await Axios.put('/api/protocol/toggleTaskCompleted/' + protocolId + '/' + taskIndex, {}, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200 || status === 264) {
            dispatch({
                type: 'PROTOCOL_EDIT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({ type: 'PROTOCOL_NOT_LOADING' })
    }
}